exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".BuildPortfolio{margin:10px;-webkit-transition-duration:0.3s;-o-transition-duration:0.3s;transition-duration:0.3s}.BuildPortfolio_card_holder{margin:0 25px}.BuildPortfolio_card_holder .slick-track{display:block}.BuildPortfolio_card_holder .slick-track::after{clear:both;height:0}.BuildPortfolio_card_holder .slick-next::before{content:none}.BuildPortfolio_card_holder .slick-prev::before{content:none}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/Create_portfolio_by_Advisor/build_portfolio/BuildPortfolio.style.scss
// module id = 1635
// module chunks = 0